import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

export type EmptyStateSize = 'sm' | 'md';

type StyledProps = {
  $size: EmptyStateSize;
  $color?: string;
};

const sizeStyles: Record<EmptyStateSize, ReturnType<typeof css>> = {
  sm: css`
    padding: 24px 16px;
    font-size: 13px;
  `,
  md: css`
    padding: 40px 16px;
    font-size: 14px;
  `,
};

export const StyledEmptyState = styled('div', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<StyledProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  font-family: 'Mangueira', sans-serif;
  color: ${({ $color }) => $color || theme.colors.gray};

  ${({ $size }) => sizeStyles[$size]}
`;

export const IconSlot = styled.span`
  display: inline-flex;
  margin-bottom: 12px;
  line-height: 0;
  color: ${theme.colors.lightGray};

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const Title = styled.p`
  margin: 0 0 4px;
  font-weight: 600;
  color: inherit;
`;

export const Description = styled.p`
  margin: 0;
  line-height: 1.4;
  color: inherit;
`;
